module.exports = __webpack_public_path__ + "media/open_box4.194eba34.mp3";